import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getTruckDetailsList } from "service/GrainManager";

export const fetchData = createAsyncThunk(
  "data/fetchData",
  async ({ currentPage, search, filter }, { rejectWithValue }) => {
    try {
      let params = {
        limit: 10,
        page: currentPage,
        search: search,
        type: filter, // Added filter parameter
      };

      if (search !== "") {
        params.page = 1;
      }

      const response = await getTruckDetailsList(params);
      if (response.status === 200) {
        return response.data.data;
      } else {
        return rejectWithValue(response.data.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState = {
  data: [],
  pageCount: 1,
  currentPage: 1,
  loading: false,
  error: null,
};

const dataSlice = createSlice({
  name: "data",
  initialState,
  reducers: {},
  extraReducers: {
    [fetchData.pending]: (state) => {
      state.loading = true;
    },
    [fetchData.fulfilled]: (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.pageCount = action.payload.pageMeta.pageCount;
      state.currentPage = action.payload.pageMeta.page;
      state.error = null;
    },
    [fetchData.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export default dataSlice.reducer;
